import { ScheduledUserError } from '@/views/community/channel/scheduled/user/scheduled-user.error';

export default ScheduledUserError;
